import type { QueryClient } from "@tanstack/react-query";

/**
 * 포트폴리오 섹션 쿼리 키가 공유하는 접두사.
 * 모든 wallet-portfolio 쿼리 키의 첫 요소는 이 접두사로 시작한다.
 */
export const WALLET_PORTFOLIO_QUERY_PREFIX = "wp:";

/**
 * 포트폴리오 전체 쿼리를 무효화해 다시 불러오게 한다.
 *
 * host가 `WalletPortfolioBody`를 `showHeader={false} autoRefresh={false}`로
 * 내장하고 자체 리프레시 버튼/폴링을 소유할 때, 같은 QueryClient(peer
 * `@tanstack/react-query`)를 넘겨 호출하면 내장 헤더의 리프레시와 동일하게
 * 동작한다.
 */
export function invalidateWalletPortfolioQueries(
  queryClient: QueryClient,
): Promise<void> {
  return queryClient.invalidateQueries({
    predicate: (query) =>
      typeof query.queryKey[0] === "string" &&
      query.queryKey[0].startsWith(WALLET_PORTFOLIO_QUERY_PREFIX),
  });
}
